exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report-absence .edit-notice{margin-top:.65rem;color:var(--color--meta);font-style:italic}.report-absence .edit-notice span.icon{margin-right:.25rem}.report-absence .edit-notice svg{position:relative;top:2px}.report-absence .edit-notice .icon-standard{stroke:var(--color--meta)}", ""]);

// exports
